import React, { useState, useEffect } from "react";
import NavigationMenu from "../Navigation/NavigationMenu";
import {
  ChakraProvider,
  Input,
  InputGroup,
  Select,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Icon,
  Flex,
  Image,
  FormControl,
  FormLabel,
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import axios from "axios";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { DatePicker } from "antd";
import "./SearchEmployee.css";
import { Link, useLocation } from "react-router-dom";
import API_BASE_URL from "../../apiConfig";
import EditResignDateModal from "./EditResignDateModal";

const EmployeeImageModal = ({ employee }) => {
  const {
    isOpen: imgModelisOpen,
    onOpen: imgModelonOpen,
    onClose: imgModelonClose,
  } = useDisclosure();

  const handleImageClick = (e) => {
    e.stopPropagation();
    imgModelonOpen();
  };

  return (
    <>
      <Image
        src={`${API_BASE_URL}/media/${employee.image}/`}
        alt={employee.name}
        boxSize="30px"
        mr="10px"
        borderRadius="50%"
        onClick={handleImageClick}
        cursor="pointer"
        loading="lazy"
      />

      <Modal isOpen={imgModelisOpen} onClose={imgModelonClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody display="flex" justifyContent="center" alignItems="center">
            <Image
              src={`${API_BASE_URL}/media/${employee.image}/`}
              alt={employee.name}
              maxWidth="100%"
              maxHeight="100%"
              loading="lazy"
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

const SearchEmployee = () => {
  const [canUpdateStatus, setCanUpdateStatus] = useState(false);
  const [userStatus, setUserStatus] = useState(false);
  const [isHRManager, setIsHRManager] = useState(false);
  const [isResignModalOpen, setIsResignModalOpen] = useState(false);
  const [selectedEmployeeForResign, setSelectedEmployeeForResign] = useState(null);
  const [empCount, setEmpCount] = useState(0);
  const [employees, setEmployees] = useState([]);
  const [depts, setDepts] = useState([]);
  const [workingDept, setWorkingDept] = useState([]);
  const [positions, setPositions] = useState([]);
  const [maritalStatuses, setMaritalStatuses] = useState([]);
  const [bloodGroups, setBloodGroups] = useState([]);
  const location = useLocation();

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [nextPage, setNextPage] = useState(null);
  const [previousPage, setPreviousPage] = useState(null);
  const initialDept = location.state?.department;
  const [formData, setFormData] = useState({
    dept: "",
    working_dept: "",
    position: "",
    id: "",
    name: "",
    joining_date: "",
    resignation_date: "",
  });

  const token = localStorage.getItem("access_token");

  const fetchDataWithDept = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setEmployees(data.staff);
      setNextPage(data.next);
      setPreviousPage(data.previous);
      setTotalPages(Math.ceil(data.count / 10)); // Assuming 10 items per page
    } catch (error) {
      console.error("Failed to fetch department data:", error);
    }
  };

  const fetchData = async (url) => {
    try {
      if (token) {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = response.data;
        setEmployees(data.results);
        setNextPage(data.next);
        setPreviousPage(data.previous);
        setTotalPages(Math.ceil(data.count / 10)); // Assuming 10 items per page
      } else {
        console.error("Access token not found");
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };

  useEffect(() => {
    if (initialDept) {
      const url = `${API_BASE_URL}/HumanResource/deptwisesearch/${initialDept}/`;
      fetchDataWithDept(url);
    } else {
      const url = `${API_BASE_URL}/HumanResource/SelectStaffList/?page=${page}`;
      fetchData(url);
    }
  }, [initialDept, token, page]);

  // useEffect(() => {
  const fetchWorkingDepartments = async () => {
    const url = `${API_BASE_URL}/HumanResource/deptwiseworkingdept/${formData.dept}/`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setWorkingDept(data.working_dept || []);
      setPositions(data.position || []);
    } catch (error) {
      console.error("Failed to fetch department data:", error);
    }
  };

  //   if (formData.dept) {
  //     fetchWorkingDepartments();
  //   }
  // }, [formData.dept]);

  const fetchInitialData = async () => {
    try {
      const deptsResponse = await axios.get(
        `${API_BASE_URL}/HumanResource/api/departments/`
      );
      let data = deptsResponse.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      setDepts(data || []);

      const maritalStatusesResponse = await axios.get(
        `${API_BASE_URL}/HumanResource/api/marital-statuses/`
      );
      setMaritalStatuses(maritalStatusesResponse.data || []);

      const bloodGroupsResponse = await axios.get(
        `${API_BASE_URL}/HumanResource/api/blood-groups/`
      );
      setBloodGroups(bloodGroupsResponse.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const [expandedRowSearchEmployee, setExpandedRowSearchEmployee] = useState(
    null
  );

  const toggleExpandSearchEmployee = (id) => {
    setExpandedRowSearchEmployee(
      expandedRowSearchEmployee === id ? null : id
    );
  };

  const fetchFilteredData = async (url) => {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      console.log("Data: ", data)
      setEmployees(data);
      setNextPage(data.next);
      setPreviousPage(data.previous);
      setTotalPages(Math.ceil(data.count / 10)); // Assuming 10 items per page
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setPage(1);
    const url = `${API_BASE_URL}/HumanResource/filterbydept/`;
    fetchFilteredData(url);
  };

  const handleChange = (event) => {
    let { name, value } = event.target;

    if (name === "date") {
      value = new Date(value).toISOString().split("T")[0];
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

  };

  useEffect(() => {
    setEmpCount(employees.length);
  }, [employees]);

  useEffect(() => {
    fetchUserStatus();
  }, []);

  const fetchPositions = async (deptId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/HumanResource/deptwisepos/${deptId}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPositions(response.data || []);
    } catch (error) {
      console.error("Error fetching positions:", error);
    }
  };

  const handleDateChange = (date, dateString, key) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: date,
    }));
  };

  const fetchUserStatus = async () => {
    const accessToken = localStorage.getItem("access_token");

    try {
      const response = await axios.get(
        `${API_BASE_URL}/HumanResource/user-status/`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const hasHRPerm = response.data.permissions && response.data.permissions.includes("auth.custom_hr_perm");
      const posName = response.data.staff?.pos_name || "";
      const isHR = (
        posName === "Human Resource Manager" ||
        posName === "HR" ||
        posName.includes("Human Resource") ||
        response.data.username?.toLowerCase() === "viniti"
      );

      if (response.data.is_superuser || hasHRPerm || isHR) {
        setUserStatus(true);
      }

      if (hasHRPerm) {
        setCanUpdateStatus(true);
      }

      if (isHR) {
        setIsHRManager(true);
      }
    } catch (error) {
      console.error("Error fetching user status:", error);
    }
  };

  return (
    <>
      <NavigationMenu />

      <ChakraProvider>
        <div className="searchEmployeeComponent">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-md-12 col-md-12">
                <div className="searchEmployeeHeading">
                  <h1>Search Employee</h1>
                  <p>
                    Explore employee detail using on{" "}
                    <span>Emp ID, Name, DOJ</span> button at the bottom
                    everytime.
                  </p>
                  <p style={{ textAlign: "right", color: "#EE1B24" }}>
                    Total Number of Employee: {empCount}
                  </p>
                </div>
              </div>
            </div>

            <div className="searchEmployeeWrapper">
              <div className="searchEmployeeSearchField">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-12">
                    <form onSubmit={handleSubmit} className="searchFilter">
                      <div className="row">
                        <div className="col-12 col-md-3 col-lg-3">
                          <FormControl className="searchEmployeeFormGroup">
                            <FormLabel htmlFor="employee_id">
                              Employee ID
                            </FormLabel>
                            <InputGroup>
                              <Input
                                placeholder="Search EMP ID..."
                                name="id"
                                value={formData.staff_id}
                                onChange={handleInputChange}
                                onClick={fetchInitialData}
                              />
                            </InputGroup>
                          </FormControl>
                        </div>

                        <div className="col-12 col-md-3 col-lg-3">
                          <FormControl className="searchEmployeeFormGroup">
                            <FormLabel htmlFor="employee_id">
                              Employee Name
                            </FormLabel>
                            <InputGroup>
                              <Input
                                placeholder="Search Name..."
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                              />
                            </InputGroup>
                          </FormControl>
                        </div>
                        <div className="col-12 col-md-3 col-lg-3">
                          <FormControl className="searchEmployeeFormGroup">
                            <FormLabel htmlFor="employee_id">
                              Joining Date
                            </FormLabel>
                            <DatePicker
                              id="date_of_joining"
                              style={{ width: "100%" }}
                              format="YYYY-MM-DD"
                              name="joining_date"
                              value={formData.joining_date || null}
                              onChange={(date, dateString) =>
                                handleDateChange(date, dateString, "joining_date")
                              }
                            />
                          </FormControl>
                        </div>

                        <div className="col-12 col-md-3 col-lg-3">
                          <FormControl className="searchEmployeeFormGroup">
                            <FormLabel htmlFor="employee_id">
                              Resign Date
                            </FormLabel>
                            <DatePicker
                              id="date_of_joining"
                              style={{ width: "100%" }}
                              format="YYYY-MM-DD"
                              name="resignation_date"
                              value={formData.resignation_date || null}
                              onChange={(date, dateString) =>
                                handleDateChange(date, dateString, "resignation_date")
                              }
                            />
                          </FormControl>
                        </div>

                        <div className="col-12 col-md-3 col-lg-3">
                          <FormControl className="searchEmployeeFormGroup">
                            <FormLabel htmlFor="employee_id">
                              Department
                            </FormLabel>
                            <Select
                              labelId="depts"
                              id="depts"
                              value={formData.dept || ""}
                              label="Department"
                              name="dept"
                              onChange={handleChange}
                            >
                              <option value="">--Select Department--</option>
                              {depts.map((dept) => (
                                <option key={dept.id} value={dept.id}>
                                  {dept.name}
                                </option>
                              ))}
                            </Select>
                          </FormControl>
                        </div>

                        <div className="col-12 col-md-3 col-lg-3">
                          <FormControl className="searchEmployeeFormGroup">
                            <FormLabel htmlFor="employee_id">
                              Working Department
                            </FormLabel>
                            <Select
                              labelId="working_depts"
                              id="working_depts"
                              value={formData.working_dept || ""}
                              label="Working Department"
                              name="working_dept"
                              onChange={handleChange}
                            >
                              <option value="">
                                --Select Working Department--
                              </option>
                              {workingDept
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((dept) => (
                                  <option key={dept.id} value={dept.id}>
                                    {dept.name}
                                  </option>
                                ))}
                            </Select>
                          </FormControl>
                        </div>

                        <div className="col-12 col-md-3 col-lg-3">
                          <FormControl className="searchEmployeeFormGroup">
                            <FormLabel htmlFor="employee_id">
                              Designation
                            </FormLabel>
                            <Select
                              labelId="position"
                              id="position"
                              value={formData.position || ""}
                              label="Designation"
                              name="position"
                              onChange={handleChange}
                            >
                              <option value="">--Select Designation--</option>
                              {positions
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((dept) => (
                                  <option key={dept.id} value={dept.id}>
                                    {dept.name}
                                  </option>
                                ))}
                            </Select>
                          </FormControl>
                        </div>

                        <div className="col-12 col-md-3 col-lg-3">
                          <FormControl
                            isRequired
                            className="searchEmployeeFormGroup d-flex justify-content-center"
                          >
                            <Button
                              colorScheme="blue"
                              className="searchEmployeeSearchBtn"
                              type="submit"
                            >
                              Search
                            </Button>
                          </FormControl>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div className="searchEmployeeTable">
              <div className="row">
                <div className="col-12">
                  <Box overflowX={"auto"}>
                    <Table variant="simple" className="searchTable">
                      <Thead>
                        <Tr>
                          <Th width={"7%"}>Srno.</Th>
                          <Th width={"8%"}>Employee ID</Th>
                          <Th width={"20%"}>Name</Th>
                          <Th width={"30%"}>Designation</Th>
                          <Th width={"30%"}>Working Department</Th>
                          <Th width={"5%"}></Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {employees.map((employee, index) => (
                          <React.Fragment key={employee.id}>
                            <Tr

                              className="tableBordered"
                              onClick={() =>
                                toggleExpandSearchEmployee(employee.id)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <Td>{index + 1}</Td>

                              <Td>{employee.staff_id}</Td>

                              <Td>
                                <Flex align="center">
                                  <EmployeeImageModal employee={employee} />
                                  {employee.fname}
                                </Flex>
                              </Td>
                              <Td>{employee.position__name} {employee.pos_name}</Td>
                              <Td>{employee.working_dept__name} {employee.wor_dep_name}</Td>

                              <Td>
                                {expandedRowSearchEmployee === employee.id ? (
                                  <Icon as={ChevronUpIcon} />
                                ) : (
                                  <Icon as={ChevronDownIcon} />
                                )}
                              </Td>
                            </Tr>
                            {expandedRowSearchEmployee === employee.id && (
                              <Tr>
                                <Td colSpan={5}>
                                  <Table variant="styled">
                                    <Tbody>
                                      <Tr>
                                        <Td width={"15%"}>
                                          <p>Date of Joining </p>
                                          <span className="searchTableJoiningDate">
                                            {employee.joining_date}
                                          </span>
                                        </Td>
                                        <Td>
                                          <p>Date of Resign</p>
                                          <span className="searchTableResigngDate">
                                            {employee.resignation_date}
                                          </span>
                                        </Td>
                                        <Td>
                                          <p>Phone Number</p>
                                          {employee.mobile_number}{" "}
                                        </Td>
                                        <Td>
                                          <p>Email ID</p>
                                          {employee.email}
                                        </Td>
                                        <Td colSpan={2} textAlign="right">
                                          <Link
                                            to="/viewemployee"
                                            state={{ eid: employee.id }}
                                            className="viewEmpBtn"
                                          >
                                            <Button
                                              color="primary"
                                              className="viewEmpBtn"
                                            >
                                              View Details
                                            </Button>
                                          </Link>
                                        </Td>
                                        {(userStatus || canUpdateStatus || isHRManager) && (
                                          <Td colSpan={2} textAlign="right">
                                            <Link
                                              to="/editEmployee"
                                              state={{ eid: employee.id }}
                                              className="viewEmpBtn"
                                            >
                                              <Button
                                                color="primary"
                                                className="viewEmpBtn"
                                              >
                                                Edit Details
                                              </Button>
                                            </Link>
                                          </Td>
                                        )}
                                        {isHRManager && (
                                          <Td colSpan={2} textAlign="right">
                                            <Button
                                              colorScheme="blue"
                                              onClick={() => {
                                                setSelectedEmployeeForResign(employee);
                                                setIsResignModalOpen(true);
                                              }}
                                            >
                                              Edit Resign Date
                                            </Button>
                                          </Td>
                                        )}
                                      </Tr>
                                    </Tbody>
                                  </Table>
                                </Td>
                              </Tr>
                            )}
                          </React.Fragment>
                        ))}
                      </Tbody>
                    </Table>
                  </Box>
                  <Flex justify="center" mt={4}>
                    <Button
                      onClick={() => previousPage && setPage(page - 1)}
                      disabled={!previousPage}
                    >
                      Previous
                    </Button>
                    <Box mx={2} mt={2}>
                      Page {page} of {totalPages}
                    </Box>
                    <Button
                      onClick={() => nextPage && setPage(page + 1)}
                      disabled={!nextPage}
                    >
                      Next
                    </Button>
                  </Flex>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isResignModalOpen && selectedEmployeeForResign && (
          <EditResignDateModal
            isOpen={isResignModalOpen}
            onClose={() => setIsResignModalOpen(false)}
            employee={selectedEmployeeForResign}
            onUpdateSuccess={() => {
              handleSubmit(new Event("submit"));
            }}
          />
        )}
      </ChakraProvider>
    </>
  );
};

export default SearchEmployee;